export enum AudienceLogicTypes {
  Group = 'AudienceGroup',
  Rule = 'AudienceRule',
}
